import calendarActivityTypes from 'constants/calendar-activity-types';
import recurringFrequencies from 'constants/recurring-frequencies';

function determineTaskDeleteButtonLabel(nature) {

  if (nature.readOnly === true) {
    return 'Leave';
  } else {
    return 'Delete';
  }

}

function determineMeetingDeleteButtonLabel(nature) {

  if (nature.readOnly === true) {
    if (nature.subType === 'APPOINTMENT') {
      return 'Cancel Appointment';
    } else {
      return 'Leave';
    }
  } else {
    return 'Delete';
  }

}

export function determineEventNature(activity, currentUser) {

  const event = activity.event;
  const nature = {
    readOnly: event.creatorId !== currentUser._id,
    recurring: event.recurring.freq !== recurringFrequencies.NEVER,
    type: activity.type,
    subType: event.type,
    isParent: event.parentId === null
  };

  return nature;

}

export function determineDeleteButtonLabel(nature) {

  if (nature.type === calendarActivityTypes.TASK) {
    return determineTaskDeleteButtonLabel(nature);
  } else {
    return determineMeetingDeleteButtonLabel(nature);
  }

}